// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsGetTechnologyPartnersDataResults = arrayOf(
  objectOf({
    salesforce_id: string,
    featured: boolean,
    name: string,
    description: string,
    short_description: string,
    partner_and_braze_description: string,
    logo_url: string,
    website_url: string,
    categories: arrayOf(string),
    industries: arrayOf(nullOrUndefined),
    specialties: arrayOf(string),
    solutions: arrayOf(nullOrUndefined),
    integration_methods: arrayOf(nullOrUndefined),
    dashboard_integration_methods: arrayOf(nullOrUndefined),
  })
);
